
import { defineComponent, onMounted, getCurrentInstance, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { setDocumentTitle } from '@/utils/dom'
import wx from 'weixin-js-sdk'

export default defineComponent({
  setup() {
    const store = useStore()
    const $route = useRoute()
    const { proxy } = getCurrentInstance()
    const isMiniProgram = store.getters.isMiniProgram
    const payMessage = reactive({
      type: '',
      orderNum: '',
      amount: '',
      orderName: '',
    })
    const handleComplete = () => {
      // let query: any = {}
      // if (proxy.$route.query.from) {
      //   query['from'] = proxy.$route.query.from
      // }
      // proxy.$router.replace({
      //   name: 'nameplate-reissue-detail',
      //   query: {
      //     ...query,
      //     ifFormConfirmSuccess: true,
      //     guid: proxy.$route.params.guid,
      //   },
      // })
      if (isMiniProgram) {
        wx.miniProgram.navigateBack({
          url: `/nameplate-reissue/detail?guid=${$route.query.guid}&ifFormConfirmSuccess=true`,
        })
      }
    }
    onMounted(async () => {
      const title = '铭牌补办申请'
      payMessage.orderNum = proxy.$route.params.orderNum as string
      payMessage.orderName = '铭牌补办申请'
      payMessage.amount = Number(proxy.$route.params.amount).toFixed(2)
      if (store.getters.isMiniProgram) {
        setDocumentTitle(title || '')
      }
    })
    return {
      payMessage,
      handleComplete,
    }
  },
})
